"use client";
import React, { useState } from "react";
import { PropertyFAQProps } from "../types";
import { ChevronRight } from "lucide-react";
import { IPropertyFAQ, ContentType } from "@/interfaces/property";
import { getContent } from "@/lib/reactutils";
import { _ } from "@/lib/i18n";

const FAQ: React.FC<PropertyFAQProps> = ({
  faqkey,
  question,
  answer,
  expanded,
  onToggle,
}) => {
  const GtmFaqId = `${question} (faq)`;

  return (
    <div
      id="FAQ item"
      className="flex flex-col w-full overflow-hidden rounded-lg mb-[12px]"
    >
      <button id={GtmFaqId}
        className="flex flex-row gap-[4px] px-[16px] py-[8px] w-full h-[36px] bg-secondary items-center"
        key={String(faqkey)}
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <span id={GtmFaqId} className="flex-1 shrink basis-0 min-w-32 text-left flex items-center">
          {question}
        </span>
        <div id={GtmFaqId}
          className={`transform transition-transform duration-300 ${
            expanded ? "rotate-90" : "rotate-0"
          }`}
        >
          <ChevronRight id={GtmFaqId} size={18} color={"hsl(var(--tertiary))"} />
        </div>
      </button>

      <div id={GtmFaqId}
        className={`overflow-hidden transition-all duration-300 ease-spring ${
          expanded
            ? "max-h-400 opacity-100 pl-4 pr-4 pb-4 pt-2"
            : "max-h-0 opacity-0"
        }`}
      >
        <div id={GtmFaqId} className="text-sm md:text-md">
          {(() => {
            try {
              return getContent(ContentType.FAQ, answer);
            } catch (error) {
              console.error(`Error rendering FAQ answer (${question}):`, error);
              return <p>{question} - Unable to display this content.</p>;
            }
          })()}
        </div>
      </div>
    </div>
  );
};
export const PropertyFAQs: React.FC<{ faqs: IPropertyFAQ[] }> = ({ faqs }) => {
  const [expandedFAQ, setExpandedFAQ] = useState<number | null>(null);

  if (!faqs || faqs.length === 0) return;
  const sortedFAQ = [].concat(faqs).sort((a, b) => a.order - b.order);
  return (
    <section
      id="PropertyFAQs"
      className="w-full text-sm md:text-md"
    >
      <h2 className="mb-2 font-semibold px-[8px] md:px-[0px] md:text-md">{_('faq').toString()}</h2>
      <div id="FaqList" className="w-full">
        {sortedFAQ.map((faq, index) => (
          <FAQ
            key={index}
            faqkey={index}
            question={faq.question}
            answer={faq.answer}
            expanded={expandedFAQ === index}
            onToggle={() =>
              setExpandedFAQ(expandedFAQ === index ? null : index)
            }
          />
        ))}
      </div>
    </section>
  );
};
